export const useDatePickerStyles = () => {
    return `
    /* Make the entire calendar background white */
    .custom-calendar.react-datepicker,
    .custom-calendar .react-datepicker__header,
    .custom-calendar .react-datepicker__month-container,
    .custom-calendar .react-datepicker__day--outside-month,
    .custom-calendar .react-datepicker__current-month,
    .custom-calendar .react-datepicker__day--keyboard-selected,
    .custom-calendar .react-datepicker__month {
      background-color: white !important;
    }
    
    /* Style for the selected date */
    .custom-calendar .react-datepicker__day--selected {
      background-color: #d4d4d8 !important; /* zinc-300 */
      border-radius: 100px !important;
      width: 36px !important;
      height: 36px !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      color: #1e293b !important; /* text-blue-950 */
    }
    
    /* Reset any range styling */
    .custom-calendar .react-datepicker__day--in-range:not(.react-datepicker__day--selected),
    .custom-calendar .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selected) {
      background-color: transparent !important;
      color: inherit !important;
    }
    
    /* Remove today's date highlighting */
    .custom-calendar .react-datepicker__day--today {
      background-color: transparent !important;
      color: inherit !important;
      font-weight: normal !important;
      border: none !important;
    }
    
    /* Fix the spacing to accommodate the larger selected date circles */
    .custom-calendar .react-datepicker__day {
      margin: 0.2rem !important;
    }
    
    /* Make the month and year dropdowns have white background */
    .custom-calendar .react-datepicker__year-dropdown,
    .custom-calendar .react-datepicker__month-dropdown {
      background-color: white !important;
      border: 1px solid #d1d5db !important;
    }
    
    /* Fix day hover styles */
    .custom-calendar .react-datepicker__day:hover {
      background-color: #f3f4f6 !important;
      border-radius: 0.3rem !important;
    }
    
    /* Reset keyboard-selected day styling */
    .custom-calendar .react-datepicker__day--keyboard-selected {
      background-color: transparent !important;
      color: inherit !important;
    }
  `;
};